export default "__VITE_PUBLIC_ASSET__236150aa__"